import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store'
import {scrollToError} from '../../../helpers/ScrollHelper'
import {
  cancelCouponFormDispatch, currencyError
} from "../../../pages/coupon/form/CouponForm-Action";

function _success(success) {
  return {type: 'UPDATE_COUPON_SUCCESS', success}
}

function _error(error) {
  return {type: 'UPDATE_COUPON_ERROR', error}
}

function _processing(processing) {
  return {type: 'UPDATE_COUPON_PROCESSING', processing}
}

function updateCoupon(id) {
  return (dispatch, getState) => {

    let {couponForm} = getState()
    dispatch(_success(null))
    dispatch(_error(null))
    dispatch(_processing(true))
    let {payload} = couponForm.data
      delete payload.organization_id
      delete payload.customer_id

    axios({
      url: apiBaseUrl(`admin/coupons/${id}`),
      method: 'put',
      dataType: 'json',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + loginToken()
      }
    })
        .then(function (res) {
          dispatch(_success(res))
          dispatch(_processing(false))
          handleSuccess(res)
          store.dispatch(cancelCouponFormDispatch())

        }).catch(function (error) {
      dispatch(_error(error.response.data.message))
      dispatch(_processing(false))
      handleError(error)

      store.dispatch(cancelCouponFormDispatch())
      if (error.response && error.response.status === 422) {
        // store.dispatch(couponFormServerValidationErrors(error.response.data.errors))
        store.dispatch(currencyError(error.response.data))
        scrollToError()
      }
    })
  }
}

export default updateCoupon
